'use client';

import { ComponentType } from 'react';
import type { AvailableCell, GardenCellPlant, Plant } from '@modules/shared-garden/business_logic';

export interface GardenGridReadOnlyProps {
  rows: number;
  columns: number;
  plants: GardenCellPlant[];
  availableCells: AvailableCell[];
  getSlotsForCell: (row: number, col: number) => number;
  plantsList: Plant[];
}

interface GardenGridReadOnlyContainerProps {
  View: ComponentType<GardenGridReadOnlyProps>;
  rows: number;
  columns: number;
  plants: GardenCellPlant[];
  availableCells: AvailableCell[];
  getSlotsForCell: (row: number, col: number) => number;
  plantsList: Plant[];
}

export function GardenGridReadOnlyContainer({
  View,
  rows,
  columns,
  plants,
  availableCells,
  getSlotsForCell,
  plantsList,
}: GardenGridReadOnlyContainerProps) {
  return (
    <View
      rows={rows}
      columns={columns}
      plants={plants}
      availableCells={availableCells}
      getSlotsForCell={getSlotsForCell}
      plantsList={plantsList}
    />
  );
}
